// eVoucher Store
import { getField } from 'vuex-map-fields'

const state = {
  cardStyles: [],
}

const getters = {
  getField,
}

const actions = {
  getCardStyles({ commit }) {
    return new Promise(resolve => {
      this.api.items.getItem('vouchers.styles').then(({ data }) => {
        commit('SET_CARD_STYLES', data.results || [])
        resolve()
      })
    })
  },
}

const mutations = {
  SET_CARD_STYLES: (state, payload) => {
    state.cardStyles = payload
    if (window && window.localStorage) {
      window.localStorage.setItem('cardStyles', JSON.stringify(payload))
    } else if (window) {
      window.cardStyles = payload
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
